/**
 * Shared react-select styles for all filter/header dropdowns across the app.
 * Usage:  import { filterSelectStyles } from '../../common/filterSelectStyles';
 *         <Select styles={filterSelectStyles} ... />
 *
 * Two size variants are exported:
 *   filterSelectStyles     – default (height 36px, font 13px)  ← most dropdowns
 *   filterSelectStylesSm   – compact  (height 34px, font 12.5px) ← dense tables
 */

const GREEN        = '#1a7d3e';
const GREEN_DARK   = '#145f30';
const GREEN_LIGHT  = '#dcfce7';
const GREEN_RING   = '0 0 0 3px rgba(26,125,62,0.12)';
const GREEN_ACTIVE = '#bbf7d0';

const baseOption = (base, { isSelected, isFocused }) => ({
    ...base,
    backgroundColor: isSelected ? GREEN : isFocused ? GREEN_LIGHT : '#fff',
    color:           isSelected ? '#fff' : isFocused ? GREEN_DARK : '#374151',
    borderRadius:    '5px',
    cursor:          'pointer',
    '&:active':      { backgroundColor: GREEN_ACTIVE },
});

export const filterSelectStyles = {
    control: (base, state) => ({
        ...base,
        minHeight:   '36px',
        height:      '36px',
        fontSize:    '13px',
        backgroundColor: '#fff',
        borderColor: state.isFocused ? GREEN : '#e5e7eb',
        borderWidth: '1.5px',
        borderRadius: '8px',
        boxShadow:   state.isFocused ? GREEN_RING : 'none',
        cursor:      'pointer',
        minWidth:    '140px',
        transition:  'border-color 0.15s',
        '&:hover':   { borderColor: GREEN },
    }),
    valueContainer:     (base) => ({ ...base, padding: '0 10px', height: '36px' }),
    singleValue:        (base) => ({ ...base, fontSize: '13px', color: '#374151' }),
    indicatorSeparator: ()     => ({ display: 'none' }),
    dropdownIndicator:  (base, state) => ({
        ...base,
        padding: '0 8px',
        color:   state.isFocused ? GREEN : '#9ca3af',
        '&:hover': { color: GREEN },
    }),
    menu: (base) => ({
        ...base,
        borderRadius: '8px',
        border:       '1.5px solid #e5e7eb',
        boxShadow:    '0 4px 16px rgba(0,0,0,0.10)',
        marginTop:    '4px',
        zIndex:       200,
        overflow:     'hidden',
    }),
    menuList:   (base) => ({ ...base, padding: '4px', maxHeight: '220px' }),
    option:     (base, state) => ({ ...baseOption(base, state), padding: '7px 10px', fontSize: '13px' }),
    placeholder:(base) => ({ ...base, color: '#9ca3af', fontSize: '13px' }),
};

/** Compact variant — use in dense tables (UserTable, BoardManage, etc.) */
export const filterSelectStylesSm = {
    ...filterSelectStyles,
    control: (base, state) => ({
        ...filterSelectStyles.control(base, state),
        minHeight:  '34px',
        height:     '34px',
        fontSize:   '12.5px',
        minWidth:   '120px',
    }),
    valueContainer:  (base) => ({ ...base, padding: '0 8px', height: '34px' }),
    singleValue:     (base) => ({ ...base, fontSize: '12.5px', color: '#374151' }),
    option: (base, state) => ({
        ...baseOption(base, state),
        padding:    '6px 10px',
        fontSize:   '12.5px',
        whiteSpace: 'nowrap',
        overflow:   'hidden',
        textOverflow: 'ellipsis',
    }),
};
